import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Card } from "reactstrap";
const config = {
  headers: {
    "X-Arqive-Api-Key": process.env.REACT_APP_API_KEY,
  },
};

const FLAG_TYPES = [
  { value: "all", label: "All Types" },
  { value: "1", label: "Suspicious/Spam" },
  { value: "2", label: "Harassment/Offensive" },
  { value: "3", label: "Inaccurate" },
  { value: "4", label: "Other" },
];

export default function ManageComments() {
  const [flagComments, setflagComments] = useState("");
  const [showReport, setshowReport] = useState("");
  const [onlyFlagged, setOnlyFlagged] = useState(true);
  const [flagTypeFilter, setFlagTypeFilter] = useState("all");
  const [resolutionActionByComment, setResolutionActionByComment] = useState({});
  const [resolutionMessageByComment, setResolutionMessageByComment] = useState({});
  const [resolvingCommentId, setResolvingCommentId] = useState(null);

  const fetchComments = () => {
    axios
      .get(`${process.env.REACT_APP_ARQIVE}/commentStory/`, config)
      .then((res) => {
        setflagComments(res.data);
      })
      .catch

      // => console.log(error)
      ();
  };

  useEffect(() => {
    fetchComments();
    // Removed flagComments from dependencies arrray was 
    // causing an infinte loop
  }, []);

  const toggleReports = (id) => {
    setshowReport((prevshowReport) => ({
      ...showReport,
      [id]: !prevshowReport[id],
    }));
  };
  const applyResolution = (commentId) => {
    const resolutionAction = resolutionActionByComment[commentId] || "delete_comment";
    const resolutionMessage = resolutionMessageByComment[commentId] || "";

    setResolvingCommentId(commentId);
    axios
      .post(
        `${process.env.REACT_APP_ARQIVE}/commentStory/${commentId}/resolve-flag/`,
        {
          action: resolutionAction,
          admin_message: resolutionMessage,
        },
        config
      )
      .then(() => {
        setResolutionActionByComment((prev) => ({ ...prev, [commentId]: "delete_comment" }));
        setResolutionMessageByComment((prev) => ({ ...prev, [commentId]: "" }));
        fetchComments();
      })
      .catch

      // => console.log(error)
      ()
      .finally(() => {
        setResolvingCommentId(null);
      });
  };
  return (
    <div>
      {flagComments && (
        <DisplayComments
          comments={flagComments}
          applyResolution={applyResolution}
          toggleReports={toggleReports}
          showReport={showReport}
          onlyFlagged={onlyFlagged}
          setOnlyFlagged={setOnlyFlagged}
          flagTypeFilter={flagTypeFilter}
          setFlagTypeFilter={setFlagTypeFilter}
          resolutionActionByComment={resolutionActionByComment}
          setResolutionActionByComment={setResolutionActionByComment}
          resolutionMessageByComment={resolutionMessageByComment}
          setResolutionMessageByComment={setResolutionMessageByComment}
          resolvingCommentId={resolvingCommentId}
        />
      )}
    </div>
  );
}

const DisplayComments = (props) => {
  const displayComments = props.comments
    .filter((c) => !props.onlyFlagged || c.flagscore > 0)
    .filter((c) => {
      if (props.flagTypeFilter === "all") return true;
      return (
        Array.isArray(c.flaggingComment) &&
        c.flaggingComment.some(
          (r) => String(r.reportType) === props.flagTypeFilter
        )
      );
    });

  return (
    <div className="container-fluid manage-container">
      manage flagged comments
      <div className="manage-filter-bar">
        <div className="manage-filter-row">
          <span className="manage-filter-label">status</span>
          <div className="manage-filter-pills">
            {[
              { value: false, label: "All Comments" },
              { value: true, label: "Flagged Only" },
            ].map((opt) => (
              <button
                key={String(opt.value)}
                className={`manage-filter-pill${props.onlyFlagged === opt.value ? " active" : ""}`}
                onClick={() => props.setOnlyFlagged(opt.value)}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>
        <div className="manage-filter-row">
          <span className="manage-filter-label">type</span>
          <div className="manage-filter-pills">
            {FLAG_TYPES.map((t) => (
              <button
                key={t.value}
                className={`manage-filter-pill${props.flagTypeFilter === t.value ? " active" : ""}`}
                onClick={() => props.setFlagTypeFilter(t.value)}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <Card className={"manage-card"} style={{ minHeight: 300 }}>
        <table className="table manage-table table-responsive-sm table-responsive-md" style={{ tableLayout: 'fixed', width: '100%' }}>
          <thead className="manage-table-head">
            <th style={{ width: '12%' }}>User </th>
            <th style={{ width: '18%' }}>Comment</th>
            <th style={{ width: '10%' }}>number of flags</th>
            <th style={{ width: '28%' }}>action</th>
            <th style={{ width: '20%' }}>reason</th>
            <th style={{ width: '12%' }}>link to story</th>
          </thead>
          <tbody>
            {displayComments.map((comment) => {
              return (
                <tr key={comment.id}>
                  <td>{comment.username ? comment.username : "Anonymous"}</td>
                  <td>{comment.description}</td>
                  <td>{comment.flagscore} flags</td>
                  <td className="manage-action-cell">
                    <div className="manage-action-controls">
                      <select
                        className="form-control form-control-sm"
                        value={props.resolutionActionByComment[comment.id] || "delete_comment"}
                        onChange={(e) =>
                          props.setResolutionActionByComment((prev) => ({
                            ...prev,
                            [comment.id]: e.target.value,
                          }))
                        }
                      >
                        <option value="delete_comment">Delete Comment</option>
                        <option value="clear_flag">Clear Flag</option>
                      </select>
                      <textarea
                        rows="2"
                        className="form-control form-control-sm"
                        placeholder="Admin note (optional)"
                        value={props.resolutionMessageByComment[comment.id] || ""}
                        onChange={(e) =>
                          props.setResolutionMessageByComment((prev) => ({
                            ...prev,
                            [comment.id]: e.target.value,
                          }))
                        }
                      />
                      <button
                        onClick={() => props.applyResolution(comment.id)}
                        className="btn btn-sm btn-block default-btn-purple"
                        disabled={props.resolvingCommentId === comment.id}
                      >
                        {props.resolvingCommentId === comment.id ? "Applying..." : "Address Flag"}
                      </button>
                    </div>
                  </td>
                  <td>
                    <button
                      onClick={() => props.toggleReports(comment.id)}
                      className="btn btn-sm default-btn-purple"
                    >
                      Show Reports
                    </button>
                    {props.showReport[comment.id]
                      ? comment.flaggingComment && (
                          <div className={"manage-reports"}>
                            <CommentReports
                              reports={comment.flaggingComment}
                              commentOwner={
                                comment.username ? comment.username : "Anonymous"
                              }
                            />
                          </div>
                        )
                      : ""}
                  </td>
                  <td>
                    <Link
                      className="sidebar-story-read-more"
                      to={`/Story/${comment.pin}`}
                    >
                      view story
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Card>
    </div>
  );
};

const CommentReports = (props) => {
  const getReportTypeLabel = (reportType) => {
    const reportTypeMap = {
      1: "Suspicious/Spam",
      2: "Harassment/Offensive",
      3: "Inaccurate",
      4: "Other",
    };

    return reportTypeMap[Number(reportType)] || "Unknown";
  };

  const getFlaggerLabel = (report) => {
    if (report.flaggerUsername) {
      return report.flaggerUsername;
    }

    if (report.flagger) {
      return `User #${report.flagger}`;
    }

    return "Unknown user";
  };

  return (
    <ul className="manage-reports-list">
      {props.reports.length > 0
        ? props.reports.map((report) => {
            return (
              <li key={report.id} className="manage-reports-item">
                <div>
                  <strong>Flagged by:</strong> {getFlaggerLabel(report)}
                </div>
                <strong>{getReportTypeLabel(report.reportType)}:</strong>{" "}
                {report.reason || "No additional details provided."}
              </li>
            );
          })
        : "none"}
    </ul>
  );
};
